export const PROFILE = {
  name: "Anushka Purohit",
  firstName: "ANUSHKA",
  pronouns: "she/her",
  location: "Mumbai, India",
  years: 9,
  title: "Creative Producer · Art Director",
  email: "anushkapurohit@gmail.com",
  phone: "+91 99711 17474",
  portrait: `${process.env.PUBLIC_URL || ""}/anushka-face.jpg`,
  photo: `${process.env.PUBLIC_URL || ""}/anushka.jpg`,
  socials: [
    { label: "Vimeo", href: "https://vimeo.com/anushkapurohit", handle: "@anushkapurohit" },
    { label: "Instagram", href: "https://instagram.com/nush_1999", handle: "@nush_1999" },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/anushkapurohit", handle: "@anushkapurohit" },
  ],
};

export const CINEMAS_SPINE_URL = "https://open.spotify.com/show/0YBkK0E7nfoafEYAqtOjsA";

export const HATS = [
  "Creative Producer",
  "Art Director",
  "Production Manager",
  "Assoc. Story Producer",
  "1st AD",
  "Production Designer",
];

export const SKILLS = [
  { label: "Creative Production", color: "yellow" },
  { label: "Production Management", color: "blue" },
  { label: "Story Producing", color: "pink" },
  { label: "Budgeting & Scheduling", color: "green" },
  { label: "Photo Stories & Content", color: "purple" },
];

export const BRANDS = [
  "Netflix", "Disney+", "Prime Video", "The Amazing Race", "Nutrabay", "Sensodent K",
  "Clove Dental", "KPMG", "Nando's", "Ballebaazi", "Giving Tuesday", "BGPPL",
];

export const MANIFESTO = [
  {
    n: "01",
    title: "I like knowing what’s going on.",
    body: "Not just what’s on the call sheet, but what’s happening around it: the people, the dynamics, the little details that can change the way a day unfolds.",
    color: "yellow",
  },
  {
    n: "02",
    title: "Curiosity killed the cat. Satisfaction brought it back.",
    body: "That's my experience in a nutshell, and it fits my cupboard of hats: Assistant Director, Production Assistant, Associate Story Producer, Production Coordinator, Art Director, Production Manager.",
    color: "pink",
  },
  {
    n: "03",
    title: "Sets are where I thrive.",
    body: "Between the people, the process and the occasional curveball — usually running on coffee from a sachet in a tiny Bisleri bottle.",
    color: "blue",
  },
  {
    n: "04",
    title: "Watch the moving parts come together.",
    body: "Somewhere between “that won’t work” and “let’s try this”… is usually where the fun begins.",
    color: "green",
  },
];

const V = (id, thumb) => ({
  id,
  thumb: `https://i.vimeocdn.com/video/${thumb}-d_1280x720`,
  url: `https://vimeo.com/${id}`,
});

export const CASE_STUDIES = [
  {
    ...V(1226237459, "2200160347-76d14a607874a4b249591fecb4c97b3d5d97ee7f375de1f8496348a8a288a474"),
    tab: "Project 01",
    date: "Netflix · S2 & S3",
    title: "Indian Matchmaking",
    role: "Production Assistant",
    blurb: "Two seasons of a global Netflix docu-series. Cross-city schedules, real families, real stakes — and a crew that had to move like one organism.",
    duration: "01:49",
    theme: "dark",
    tags: ["Docu-series", "Netflix", "Unscripted"],
  },
  {
    ...V(1226241177, "2200165129-d5f20c71aeb17d58ae9c08ad71faf3d04187784bca02f8d921661443dea045da"),
    tab: "Project 02",
    date: "Prime Video India",
    title: "Mission Start Ab",
    role: "Associate Story Producer",
    blurb: "Shaping founder stories for Amazon's startup reality format — tracking arcs across episodes and keeping the drama honest to the pitch.",
    duration: "01:56",
    theme: "yellow",
    tags: ["Reality", "Story", "Prime Video"],
  },
  {
    ...V(1226237458, "2200160523-7710f52de17acbe7c5ba04ec34d5b3d760d748171e835073a542e5dc996bd88c"),
    tab: "Project 03",
    title: "Sensodent K",
    subtitle: "Try Karke Dekho",
    category: "Advertising · Toothpaste",
    role: "Associate Producer",
    blurb: "Six ads. Multiple locations across Mumbai. One campaign to bring together. From prep to shoot, the focus was keeping every piece moving towards the same idea.",
    duration: "00:30",
    theme: "paper",
    url: "https://vimeo.com/1226237458?fl=pl&fe=sh",
    tags: [],
  },
  {
    id: "YcDPPXl5dqU",
    youtubeId: "YcDPPXl5dqU",
    url: "https://youtu.be/YcDPPXl5dqU?si=m2s_ktjtpsqM58us",
    thumb: "https://i.ytimg.com/vi/YcDPPXl5dqU/hqdefault.jpg",
    tab: "Project 04",
    title: "WAVES Summit 2025",
    subtitle: "World Audio Visual & Entertainment Summit",
    category: "Event · Media & Entertainment",
    role: "Creative Producer",
    blurb: "A large-scale creative ecosystem needs more than ideas. The work involved fleshing out ideas, shaping the thinking behind them, and turning them into creative assets ready for execution.",
    theme: "green",
    mediaRight: true,
    tags: [],
  },
];

export const WORKS = [
  { ...V(1226237457, "2200160564-218fddcfb034b6b1a77863edd658f7eab093c8cac6c31ee9ebe6f12021fb19ae"), title: "Nutrabay Brand Film", sub: "feat. Radhika Madan", brand: "Nutrabay", role: "Assistant Director", duration: "00:54", color: "green" },
  { ...V(1226237450, "2200160572-4f8ec932ebe7d4c88147df33082cf0556c86220087611d8a534338d20c692a72"), url: "https://vimeo.com/1226237450?fl=pl&fe=sh", title: "Sensodent K — Yacht", sub: "30 sec · Hindi", brand: "Sensodent K", role: "Associate Producer", duration: "00:30", color: "blue" },
  { ...V(1226237458, "2200160523-7710f52de17acbe7c5ba04ec34d5b3d760d748171e835073a542e5dc996bd88c"), title: "Sensodent K — Hiking", sub: "30 sec · Telugu", brand: "Sensodent K", role: "Associate Producer", duration: "00:30", color: "blue" },
  { ...V(1226237456, "2200160349-501094b36f23227c474858b679d688ef511878b66b778e4889dbfedd55ad0c12"), title: "Teeth Have Feelings Too", sub: "Bad breath · Clove Dental", brand: "Clove Dental", role: "Production Manager", duration: "00:21", color: "pink" },
  { ...V(1226237453, "2200160178-e19dc2b67bb4583d440236ef22a60ac52e7880d0b6c11582b3ae5b3f5d0901e4"), url: "https://vimeo.com/1226237453?fl=pl&fe=sh", title: "Virgio - We are more than that!", sub: "", brand: "Virgio", role: "First AD", duration: "01:02", color: "pink" },
  { ...V(1226237448, "2200160169-f139bf1a7e4492e7faa4d7c7930255cb93f21f66f70efdee5f1cd97fc4308ace"), url: "https://vimeo.com/1226237448?fl=pl&fe=sh", title: "Rajdhani Sattu", sub: "#JeetKiShakti · 25 sec", brand: "Rajdhani Sattu", role: "First AD", duration: "00:25", color: "purple" },
  { id: "ycD5rQc-_EU", youtubeId: "ycD5rQc-_EU", url: "https://youtu.be/ycD5rQc-_EU?si=ZuXFuX1JMT_GjSUG", thumb: "https://i.ytimg.com/vi/ycD5rQc-_EU/hqdefault.jpg", title: "Grill the Bill Nando's", sub: "", brand: "Nando's", role: "First AD", color: "orange" },
  { ...V(1226241176, "2200165058-42c4514e6853d48a734fca1c4436188467f8c04c71a0b622acf178334fe7ce94"), title: "Fight Back Hair Loss", sub: "Digital film", brand: "DVC", role: "Production", duration: "00:20", color: "orange" },
  { ...V(1226237454, "2200160463-e988be90c9c1691b98326f65505cb0eba787add9090df2ecde8c4455d9497a88"), title: "Indian Matchmaking S2", sub: "Official trailer · Netflix", brand: "Netflix", role: "Production Assistant", duration: "01:52", color: "yellow", slate: true },
];

export const ROLES = {
  production: [
    ["Senior Creative Producer", "Collective Creative Labs · 1 yr"],
    ["Production Assistant", "Indian Matchmaking S2 & S3 · Netflix"],
    ["Associate Story Producer", "Mission Start Ab · Amazon Prime Video"],
    ["Director's Assistant", "Documentary Series · Disney+"],
    ["Asst. Art", "The Amazing Race · Season 32"],
    ["Production Coordinator", "Sisters S4 · Israeli TV series"],
    ["Associate Producer", "Sensodent K TVC ×6"],
    ["Production Manager", "Clove Dental DVC ×4"],
    ["Production Manager", "KPMG Clean Room · Corporate"],
    ["Associate Producer", "BGPPL Corporate Films"],
    ["Asst. Director", "Nutrabay · Nudo Films"],
    ["Asst. Director + PA", "Nando's TV · Nudo Films"],
    ["1st Asst. Director", "Berkowitz DVC · Panaroma"],
    ["1st AD", "Whistle Tooth Aligners"],
    ["Production Manager", "Giving Tuesday · Stories Collection Drive"],
    ["Asst. to Executive Producer", "Three Autumn Films"],
    ["Production & Direction", "Ballebaazi Advert · Nudo Films"],
  ],
  art: [
    ["Production Designer / Art Director", "Presence"],
    ["Art Director", "Dubki · ACFM Graduation Film"],
    ["Art Director", "Smoke and Drop · ACFM Graduation Film"],
    ["Production & Costume Designer", "Padosan · ACFM Grad Film"],
    ["Asst. Production Designer + Set Dresser", "StoryBoard"],
    ["Art Director", "Villan · Short film (Cinemaghar)"],
    ["Production Designer", "Open Cheste! · College semend"],
    ["Asst. Production Manager", "Night of 16th January · Ayn Rand (Theatre)"],
    ["Production", "A Streetcar Named Desire · Tennessee Williams"],
  ],
};

export const EDUCATION = [
  ["BFA Direction + Cinematography", "Annapurna College of Film and Media", "2017 — 2021"],
  ["IBDP · Hindi, English & Theatre", "GD Goenka World School", "2015 — 2017"],
  ["IGCSE", "Pathways School, Gurgaon", "2013 — 2015"],
];

export const TRUSTED = [
  { name: "NETFLIX", bg: "#141414", fg: "#E50914" },
  { name: "Disney+", bg: "#0E1B4D", fg: "#ffffff" },
  { name: "prime video", bg: "#00A8E1", fg: "#0F1111" },
  { name: "KPMG", bg: "#00338D", fg: "#ffffff" },
  { name: "NANDO'S", bg: "#F26B3A", fg: "#141414" },
  { name: "Nutrabay", bg: "#8BD5B2", fg: "#141414" },
  { name: "Sensodent", bg: "#F7D44C", fg: "#141414" },
  { name: "Clove Dental", bg: "#F6A6C1", fg: "#141414" },
];
